import { styled } from '@mui/system'

export const StyledIssueStatus = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;
`
